import React from 'react';
import { info } from "@randajan/simple-app/info";


import { Block } from "@randajan/jet-react/dom/block";

import { extendURL } from "@randajan/oauth2-client";
import { page } from '@randajan/jet-react/base/page';

import { Button } from '@randajan/jet-react/dom/form';
import tab from '@randajan/jet-react/base/tab';
import { Img } from '@randajan/jet-react/dom/img';

import { icons } from '../../icons';

import "./GrantButton.scss";


const redirect = async (kind) => {
    const { pathname } = page.get();
    const { srcTag } = tab.get();
    window.location = extendURL(`${info.home}/oauth/${kind}`, {
        srcPath: pathname,
        srcTag
    });
}

export const GrantButton = (props) => {
    const { id, lock } = props;

    return (
        <Button className="GrantButton" onSubmit={_ => redirect(id)} lock={lock}>
            <Img src={icons?.[id]} noFetch />
            <p>
                <span className="title">Přihlásit se přes {String.jet.capitalize(id)}</span>
                {lock && <span className="outOfOrder">Dočasně nedostupné</span>}
            </p>
        </Button>
    )
}

